import React from 'react';
import PropTypes from 'prop-types';

function AuthFormContainer(props) {
  const { children, message, style, title } = props;

  return (
    <div className='fullPageFormContainer marginAbove' style={style}>
      { message }
      
      <h2 className='formTitle'>{title}</h2>
      { children }        
    </div>
  );
}

AuthFormContainer.propTypes = {
  children: PropTypes.node,
  message: PropTypes.node,
  style: PropTypes.object,
  title: PropTypes.node
};

export default AuthFormContainer;
